import { Component } from 'react';
import PropTypes from 'prop-types';
import EmptyChart from 'legacy/javascripts/components/empty_chart.es6.jsx';

function defaultLabelHandler(e, chart) {
  let chartElement = chart.getElementAtEvent(e)[0];
  return chart.data.labels[chartElement._index];
}

class BaseChart extends Component {
  constructor() {
    super();
    this._chart = null;
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const labelHandler = this.props.labelHandler || defaultLabelHandler;

    if (this._chart.getElementAtEvent(e).length > 0) {
      const label = labelHandler(e, this._chart);
      const filters = {
        [this.props.labelParam]: label,
        ...this.props.extraParams,
      };
      this.props.chartHandler({ filters, mixpanelId: this.props.id });
    }
  }

  draw() {
    if (this.props.labels.length > 0) {
      const ctx = this.refs[this.props.id].getContext('2d');

      const data = {
        labels: this.props.labels,
        datasets: this.props.datasets,
      };

      const responsiveChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
      };

      this._chart = new Chart(ctx, {
        type: this.props.type,
        data: data,
        options: {
          onClick: this.handleClick,
          ...responsiveChartOptions,
          ...this.props.options,
          locale: (window.Localize && window.Localize.getLanguage()) || 'en',
        },
      });
    }
  }

  componentDidMount() {
    this.draw();
  }

  componentDidUpdate(prevProps) {
    if (this.props.labels != prevProps.labels) {
      if (this._chart) {
        this._chart.destroy();
      }
      this.draw();
    }
  }

  render() {
    if (this.props.labels.length > 0) {
      return (
        <div className="canvas-container">
          <canvas id={this.props.id} ref={this.props.id} />
        </div>
      );
    } else {
      return <EmptyChart />;
    }
  }
}

export default BaseChart;
